// extracted by mini-css-extract-plugin
module.exports = {"waitingBox":"waitingBox--ze2QU","step":"step--2lfUn","pollingSteps":"pollingSteps--2ho6S","text":"text--3VZmK","operationBG":"operationBG--3TsR9"};